export const version = {
  frontendAppVersion: '0.49.0',
  backendAppVersion: '0.49.0',
  authAppVersion: '0.49.0',
  discAppVersion: '0.49.0',
  gatewayAppVersion: '0.49.0',
  gcmPricingServiceVersion: '2.0',
};
